import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57c07e93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapSpHeader" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrapSns" }, null, -1))
const _hoisted_3 = { class: "wrapTitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "headerTitle" }, "kazuki", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "headerTitle" }, "yoshida", -1))
const _hoisted_6 = { class: "wrapMenu" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("about")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("blog")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: _ctx.$C.route.home
      }, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, {
        to: _ctx.$C.route.about,
        class: "menu"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: _ctx.$C.route.blog,
        class: "menu"
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}